import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-v-small', 'IconLetterVSmall', [
  ['path', { d: 'M10 8l2 8l2 -8', key: 'svg-0' }],
]);
